import { HexMap } from "./HexMap";
import { HexMapNoteBuilder } from "./HexMapNoteBuilder";
import { Key, KeyParams } from "./Key";
import DisplayConfig from "./DisplayConfig";

export interface HexMapBuilderParams{
    rows:number,
    columns:number,
    tonic:number, 
    radius:number, 
    noteDisplayConfig?:DisplayConfig,
    centerKey?:number[],
    keySingleSelect?:boolean
}
export function BuildHexMap(params:HexMapBuilderParams){
    return new HexMapBuilder(params).build()
}
export class HexMapBuilder{
    params:HexMapBuilderParams
    hexMap:HexMap
    constructor(params:HexMapBuilderParams){
        this.params = params
        this.hexMap = new HexMap({displayConfig:this.getDisplayConfig()})
    }
    getDisplayConfig(){
        if(this.params.noteDisplayConfig){return this.params.noteDisplayConfig}
        return new DisplayConfig({keyRadius:this.params.radius})
    }
    build(){
        this.buildKeys()
        this.buildNotes()
        return this.hexMap
    }
    buildNotes(){
        const noteBuilder:HexMapNoteBuilder = new HexMapNoteBuilder(this.hexMap, this.params)
        this.hexMap.keys.flat().forEach((key:Key)=>{
            noteBuilder.buildNotesForKey(key)
        })
    }
    buildKeys(){
        for(let rowIndex = 0; rowIndex < this.params.rows; rowIndex++){
            let row:Key[] = []
            this.hexMap.keys.push(row)
            for(let columnIndex = 0; columnIndex < this.params.columns; columnIndex++){
                const keyIndex = this.hexMap.keys.flat().length
                const tonic = this.getKeyTonic(rowIndex, columnIndex)
                const [x,y] = this.getKeyCoordinates(rowIndex, columnIndex)
                const keyParams:KeyParams = {
                    tonic: tonic,
                    keyIndex:keyIndex,
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    x: x,
                    y: y,
                    radius: this.params.radius
                }
                let key:Key = new Key(keyParams)
                row.push(key)
            }
        }
    }
    getKeyTonic = (rowIndex:number, columnIndex:number) => {
        // first one
        if(rowIndex===0 && columnIndex===0){ 
            return this.params.tonic
        }
        // has neighbor to left
        if(columnIndex !== 0){
            const previousTonic:number = this.hexMap.keys[rowIndex][columnIndex-1].params.tonic
            const tonic =  (previousTonic + 9) % 12
            return tonic
        }
        // odd row get flatsixth
        if(rowIndex % 2 === 1){
            const flatSixthKey:Key = this.hexMap.keys[rowIndex-1][columnIndex]
            const flatSixthKeyTonic:number = flatSixthKey.params.tonic
            const tonic = (flatSixthKeyTonic + 4) % 12
            return tonic 
        }
        // even row get fourth
        const fourthKey:Key = this.hexMap.keys[rowIndex-1][columnIndex]
        const fourthKeyTonic:number = fourthKey.params.tonic
        const tonic = (fourthKeyTonic + 7) % 12
        return tonic
 
    }
    getKeyCoordinates = (rowIndex:number, columnIndex:number) => {
        const xOffset:number = 0
        const yOffset:number = 0
        const keyWidth:number = (this.params.radius * .866) * 2
        const rowXOffset:number = ( (rowIndex % 2) === 0 ) ? keyWidth/2 : keyWidth
        const rowYOffset:number = this.params.radius
        const x:number = xOffset + rowXOffset + (columnIndex * keyWidth)
        const y:number = yOffset + rowYOffset + (rowIndex * (this.params.radius * 1.5))
        return [x,y] 
    }
}